var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ReactChakraSelect as Select } from '@springcare/sh-component-library';
import { chakraStyles } from './styles';
/**
 * A wrapper for chakra-react-select, which is itself a wrapper for the popular react component
 * react-select, made using Chakra UI.
 *
 * TODO: Modify FormSelect to use DropDown. Will need to use react-hook-form's Controller
 * component or hook. See https://react-hook-form.com/api/usecontroller/controller
 *
 * NOTE: See how this Select is from the chakra-react-select library, not the native chakra one.
 * Docs: https://github.com/csandman/chakra-react-select#usage
 * Docs examples: https://codesandbox.io/s/chakra-react-select-ts-demo-vz9ut?file=/app.tsx
 *
 * NOTE: If needed, there's also imports for a select that has user-creatable options,
 * as well as an async select that can wait for fetched options from the BE.
 *
 * @param {DropDownProps} props DropDownProps
 * @returns {React.ReactNode} DropDown
 */
var DropDown = function (_a) {
    var _b = _a.isMulti, isMulti = _b === void 0 ? false : _b, name = _a.name, options = _a.options, _c = _a.placeholder, placeholder = _c === void 0 ? 'Select' : _c, isInvalid = _a.isInvalid, isDisabled = _a.isDisabled, _d = _a.closeMenuOnSelect, closeMenuOnSelect = _d === void 0 ? true : _d, _e = _a.hideSelectedOptions, hideSelectedOptions = _e === void 0 ? false : _e, _f = _a.selectedOptionStyle, selectedOptionStyle = _f === void 0 ? 'check' : _f, colorScheme = _a.colorScheme, tagVariant = _a.tagVariant, onChange = _a.onChange, props = __rest(_a, ["isMulti", "name", "options", "placeholder", "isInvalid", "isDisabled", "closeMenuOnSelect", "hideSelectedOptions", "selectedOptionStyle", "colorScheme", "tagVariant", "onChange"]);
    return (_jsx(Select, __assign({ isMulti: isMulti, name: name, options: options, placeholder: placeholder, isInvalid: isInvalid, isDisabled: isDisabled, closeMenuOnSelect: closeMenuOnSelect, hideSelectedOptions: hideSelectedOptions, selectedOptionStyle: selectedOptionStyle, colorScheme: colorScheme, tagVariant: tagVariant, onChange: onChange, chakraStyles: chakraStyles }, props)));
};
export { DropDown };
